import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export interface DocumentExpiryDraft {
    enabled: boolean;
    recipients_initialized?: boolean;
    title: string;
    timezone: string;
    days_before: number;
    time: string;
    on_date?: string | null;
    recipient_user_ids: number[];
    recipient_roles: string[];
    replaces_file_id: number | null;
}

export function expiryPreview(expiry: string, draft: DocumentExpiryDraft): string {
    if (!expiry || !draft.timezone || !draft.time) return 'Choose a date, time and timezone.';
    try {
        const date = draft.on_date || dayjs(expiry).subtract(Number(draft.days_before), 'day').format('YYYY-MM-DD');
        const at = dayjs.tz(`${date} ${draft.time}`, draft.timezone);
        return `${at.format('D MMM YYYY, h:mm A')} (${draft.timezone})${at.isBefore(dayjs()) ? ' - choose a future time' : ''}`;
    } catch {
        return 'Choose a valid timezone.';
    }
}

/** Upload persistence is independent; a failed reminder keeps its draft for retry. */
export async function createDocumentExpiry(file: any, draft: DocumentExpiryDraft | null): Promise<void> {
    if (!draft?.enabled) return;
    file.expiryDraft = { ...draft };
    try {
        const payload: any = { ...draft, defer_past: true };
        const { data } = await window.tenantAxios.post(`/company-diary/documents/${file.id}/expiry`, payload);
        file.expiryDiary = data.diary;
        file.expiryError = '';
        file.expiryDraft = null;
    } catch (error: any) {
        file.expiryError =
            error?.response?.data?.message || error?.message || 'File saved. Reminder setup needs attention.';
    }
}
